import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const organisationRecordBranchesWidget: DashboardWidgetConfiguration = {
  widgetId: "organisation.record.branches",
  name: "Active branches",
  description: "Active branches for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "organisation.current-branches",
      ...period(1),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "branch_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Active branches",
    subtext: "",
    icon: "briefcase",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 1,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
